/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { getEntityTypesAPI, getEntityType } from 'EntityTypeAPI';
import { filterUserResourcesToArray } from 'Utils';

export const GET_ENTITYTYPES_DATA = 'GET_ENTITYTYPES_DATA';
export const GET_ENTITYTYPES_DATA_FAILURE = 'GET_ENTITYTYPES_DATA_FAILURE';
export const GET_ENTITYTYPES_DATA_SUCCESS = 'GET_ENTITYTYPES_DATA_SUCCESS';

export const GET_ENTITYTYPE_DETAIL_SUCCESS = 'GET_ENTITYTYPE_DETAIL_SUCCESS';
export const GET_ENTITYTYPE_DETAIL_FAILURE = 'GET_ENTITYTYPE_DETAIL_FAILURE';
export const GET_ENTITYTYPE_DETAIL = 'GET_ENTITYTYPE_DETAIL';

export const UPDATE_ENTITYTYPE = 'UPDATE_ENTITYTYPE';
export const UPDATE_ENTITYTYPE_FAILURE = 'UPDATE_ENTITYTYPE_FAILURE';
export const UPDATE_ENTITYTYPE_SUCCESS = 'UPDATE_ENTITYTYPE_SUCCESS';

// ---------------------------------------------------
// fetch entitytype data -----------------------------
// ---------------------------------------------------
// action
const getEntityTypesData = () => ({
  type: GET_ENTITYTYPES_DATA,
});

// action
const getEntityTypesDataFailure = error => ({
  type: GET_ENTITYTYPES_DATA_FAILURE,
  payload: error,
});

// action
const getEntityTypesDataSuccess = storeData => ({
  type: GET_ENTITYTYPES_DATA_SUCCESS,
  payload: storeData,
});

export const fetchEntityTypesData =
  () =>
  (dispatch, getState, { dataCache }) => {
    dispatch(getEntityTypesData());
    return getEntityTypesAPI()
      .then(responseJson => filterUserResourcesToArray(responseJson, dataCache))
      .then(responseJson => {
        dispatch(getEntityTypesDataSuccess(responseJson || ''));
        return responseJson;
      })
      .catch(error => {
        dispatch(getEntityTypesDataFailure(error));
      });
  };

// --------------------------------------------------
// fetchEntityTypeDetails
// --------------------------------------------------

const getEntityTypeDetails = () => ({
  type: GET_ENTITYTYPE_DETAIL,
});

// action
const getEntityTypeDetailsFailure = error => ({
  type: GET_ENTITYTYPE_DETAIL_FAILURE,
  payload: error,
});

// action
const getEntityTypeDetailsSuccess = storeData => ({
  type: GET_ENTITYTYPE_DETAIL_SUCCESS,
  payload: storeData,
});

export const fetchEntityTypeDetails = entityTypeName => dispatch => {
  dispatch(getEntityTypeDetails());
  return getEntityType(entityTypeName)
    .then(responseJson => {
      dispatch(getEntityTypeDetailsSuccess(responseJson || ''));
      return responseJson;
    })
    .catch(error => {
      dispatch(getEntityTypeDetailsFailure(error));
    });
};
